export default function TextArea({title = '', placeholder='',
                                     onChange,
                                     rows = 4,
                                     id,
                                     register = {},
                                     defaultValue,
                                     ...rest
}) {

    return (
        <div>
            <label htmlFor={id} className="block text-sm text-md py-2 font-medium text-gray-700">
                {title}
            </label>
            <textarea
                {...register}
                id={id}
                //name={id}
                rows={rows}
                className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border border-gray-300 rounded-md"
                placeholder={placeholder}
                //onChange={onChange}
                defaultValue={defaultValue}
                {...rest}

            />
        </div>
    );

}
